import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CustomerForm extends ThemeComponent {
    @Ref({ required: false }) recoverToggle!: HTMLButtonElement[];
    @Ref({ required: false }) recover!: HTMLElement;
    @Ref() form!: HTMLElement;

    protected activePasswordForgottenForm: boolean = false;

    /**
     * Initialise.
     */
    init() {

        this.showForm();

        for (const button of this.recoverToggle) {
            button.addEventListener("click", () => {
                if (!this.activePasswordForgottenForm) {
                    this.showPasswordRecover();
                } else {
                    this.hidePasswordRecover();
                }
            });
        }
    }

    /**
     * Toggle Recover password form.
     */
    showPasswordRecover() {
        this.recover.classList.add('is-active');
        this.form.classList.remove('is-active');
        this.scrollIntoView();
        this.activePasswordForgottenForm = true;
    }

    hidePasswordRecover() {
        this.recover.classList.remove('is-active');
        this.form.classList.add('is-active');
        this.scrollIntoView();
        this.activePasswordForgottenForm = false;
    }

    /**
     * Show / hide forms based of consitions.
     * @returns
     */
    showForm() {

        if (!this.recover){ return; }

        if (location.href.indexOf('#recover') !== -1) {
            this.recover.classList.add('is-active');
            this.form.classList.remove('is-active');
        } else {
            this.recover.classList.remove('is-active');
            this.form.classList.add('is-active');
        }


    }
}
